/**
 * @GENERATED from Figma node 3638:52269
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const NotSignedDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#978F86"
      d="M11.115 10.655v4.244c.58-.15 1.19-.15 1.77 0v-4.244zM12 15.968a.885.885 0 1 0 .886.885.84.84 0 0 0-.886-.885"
    />
    <path
      fill="#978F86"
      fillRule="evenodd"
      d="M1 21.28 12 2.72l11 18.56zm18.891-1.77L12 6.193 4.109 19.51z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(NotSignedDark);
export { ForwardRef as NotSignedDark };
